import React from "react";
import ReactDOM from "react-dom/client"; // Use the new ReactDOM API
import Helmet from "react-helmet";
import App from "./App";
import "./index.css";
import * as serviceWorker from "./serviceWorker";

const root = ReactDOM.createRoot(document.getElementById("root")); // Create a root
root.render(
  <React.StrictMode>
    <Helmet>
      <script
        src="http://cdn.credly.com/assets/utilities/embed.js"
        type="text/javascript"
      />
    </Helmet>
    <App />
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
